export default __webpack_public_path__ + "static/media/Chattri-of-Devi-Ahilya-Bai.472923aa.jpg";